import React from 'react'
import TrashIconSVG from "../../../assets/icons/trash.svg"
export const TrashIcon: React.FC = () => {
  return (
    <img src={TrashIconSVG} alt="" className="w-[12px] h-[17px] cursor-pointer" />
  )
}
